// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import iView from "iview";
import App from "./App";
import { router } from "./router/index";
import "iview/dist/styles/iview.css";
import "./Common/iviewthem.css";
import axios from "axios";
import "./Common/CommonLess.less";
import store from "./Common/Store.js";
import CommonMethods from "./Common/CommonMethods.js";
import VueCookies from "vue-cookies";
import jquery from "jquery";
import i18n from "./Language";
import "babel-polyfill";
import "./Common/static/iconfont/iconfont.css";
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(iView);
Vue.prototype.$CommonMethods = CommonMethods;
Vue.prototype.$cookies = VueCookies;
Vue.prototype.$jquery = jquery;
Vue.prototype.$store = store;
VueCookies.config("0");
// axios请求开始
var loadpage = 0;
axios.interceptors.request.use(
  function(config) {
    if (config.showloading) {
      if (loadpage <= 0) {
        ThisVue.$Spin.show();
      }
    }
    loadpage++;
    if (config.url == undefined || config.url == null || config.url == "") {
      if (config.data.ExCode == "OpenAuth") {
        if (process.env.NODE_ENV == "development") {
          config.url = "http://www.chinairap.cn:8081/OpenAuth/PCWeb/json";
          // config.url = 'http://192.168.57.11:55556/OpenAuth/PCWeb/json'
        } else {
          config.url = "/OpenAuth/PCWeb/json";
        }
      } else {
        if (process.env.NODE_ENV == "development") {
          // config.url = 'http://192.168.57.11:55556/exchange/sms/json/IRAP_SSO_' + config.data.ExCode
          if (config.data.ExCode == "GetOpenPOsNoPFEPSet") {
            config.url =
              "http://www.chinairap.cn:8081/exchange1/PCWeb/json/IRAP_EDI_" +
              config.data.ExCode;
          } else if (config.data.Code == "IRAP_EDI_") {
            config.url =
              "http://www.chinairap.cn:8081/exchange1/PCWeb/json/IRAP_EDI_" +
              config.data.ExCode;
          } else {
            config.url =
              "http://www.chinairap.cn:8081/exchange1/sms/json/IRAP_SSO_" +
              config.data.ExCode;
          }
        } else if (process.env.NODE_ENV == "production") {
          if (config.data.ExCode == "GetOpenPOsNoPFEPSet") {
            config.url = "/exchange1/PCWeb/json/IRAP_EDI_" + config.data.ExCode;
          } else if (config.data.Code == "IRAP_EDI_") {
            config.url = "/exchange1/PCWeb/json/IRAP_EDI_" + config.data.ExCode;
          } else {
            config.url = "/exchange1/PCWeb/json/IRAP_SSO_" + config.data.ExCode;
          }
        }
      }
    }
    // if (config.data.ExCode == "OpenAuth") {
    //   config.url = "/OpenAuth/PCWeb/json";
    // } else {
    //   config.url = "http://192.168.57.12:55556/exchange/PCWeb/json/IRAP_SSO_" + config.data.ExCode
    //   // config.url = "/exchange1/PCWeb/json/IRAP_SSO_" + config.data.ExCode;
    // }
    config.headers.Accept = "*/*";
    config.headers["Content-Type"] = "application/xmlstream; charset=utf-8";
    config.data = JSON.stringify(config.data);
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
    // config.transformRequest = [function (data) {
    //   let ret = ''
    //   for (let it in data) {
    //     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    //   }
    //   return ret
    // }];
    return config;
  },
  function(error) {
    // 对请求失败做处理
    return Promise.reject(error);
  }
);

// axios请求回调
axios.interceptors.response.use(
  function(response) {
    ThisVue.$cookies.config("0", "/");
    // 对响应数据做处理
    loadpage--;
    if (loadpage <= 0) {
      ThisVue.$Spin.hide();
    }
    if (response.data.ErrCode == "999999" || response.data.ErrCode == "50207") {
      ThisVue.$cookies.remove("SystemInfo");
      ThisVue.$cookies.remove("access_token");
      ThisVue.$cookies.remove("UserInfo");
      ThisVue.$Modal.error({
        title: "系统错误：",
        content: response.data.ErrText,
        okText: "OK",
        cancelText: "Cancel",
        onOk: () => {
          if (window.frames.length != parent.frames.length) {
            window.parent.location.href = "/";
          } else {
            if (
              response.data.ErrCode == "999999" &&
              response.data.ErrText.indexOf("密码已过期") != -1
            ) {
              window.location.hash = "#/ChangePWD";
            } else {
              window.location.href = "/";
            }
          }
        }
      });
    } else {
      return response;
    }
  },
  function(error) {
    // 对响应错误做处理
    loadpage--;
    if (loadpage <= 0) {
      ThisVue.$Spin.hide();
    }
    ThisVue.$Notice.error({
      title: "axios请求错误或服务器错误",
      desc: false
        ? ""
        : "错误代码：" + error.request.status + "；错误信息：" + error.message,
      duration: 0
    });
    // return Promise.reject(error);
  }
);

/* eslint-disable no-new */
var ThisVue = new Vue({
  el: "#app",
  i18n,
  router: router,
  store: store,
  components: {
    App
  },
  template: "<App/>",
  mounted() {
    thisloginvue = this;
  },
  beforeCreate() {
    if (
      this.$router.history.pending.name == "SelectSystem" ||
      this.$router.history.pending.name == "Login" ||
      this.$router.history.pending.name == "ResetPWD" ||
      this.$router.history.pending.name == "SSOLogin"
    ) {
      return;
    }

    if (
      this.$cookies.get("access_token") == undefined ||
      this.$cookies.get("access_token") == null ||
      this.$cookies.get("access_token") == ""
    ) {
      if (window.frames.length != parent.frames.length) {
        window.parent.location.href = "/";
      } else {
        window.location.href = "/";
      }
    }

    if (
      this.$cookies.get("access_token") != undefined &&
      this.$cookies.get("access_token") != null &&
      this.$cookies.get("access_token") != "" &&
      this.$cookies.get("SystemInfo") != undefined &&
      this.$cookies.get("SystemInfo") != null &&
      this.$cookies.get("SystemInfo") != "" &&
      window.frames.length == parent.frames.length &&
      (this.$store.state.menuListTree == undefined ||
        this.$store.state.menuListTree == null ||
        this.$store.state.menuListTree.length <= 0)
    ) {
      this.$axios({
        method: "post",
        data: {
          ExCode: "AVAMENUS",
          access_token: this.$cookies.get("access_token"),
          SystemID: this.$cookies.get("SystemInfo").SystemID,
          IsBSMode: 1
        }
      })
        .then(response => {
          if (response.data.ErrCode == "0") {
            this.$store.commit("SetMenu", response.data.Rows);
            if (this.$store.state.openmuenlist.length <= 0) {
              let valSystemInfo = this.$cookies.get("SystemInfo");
              let namemenu = {
                HTTPURL: valSystemInfo.DefaultPage,
                MenuID: 0
              };
              this.$store.commit("changeiframesrc", namemenu);
            }
          } else {
            ThisVue.$Notice.error({
              title: response.data.ErrCode,
              desc: false ? "" : response.data.ErrText,
              duration: 0
            });
          }
        })
        .catch(function(error) {});
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js